module.exports = __webpack_public_path__ + "img/cash-voucher.1947a1cd.png";